export const EMPTY_ARRAY = new Array();
export const EMPTY_STRING = new String();
export const EMPTY_OBJECT = new Object();
